import { AccordionContainer } from "../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container";


export const DbaRegistriesPanInfoComponent = ({ handleInnerFormChange, selectedDbaRegistry }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Name As Per Pan"
                        name="name_as_per_pan"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigPan.name_as_per_pan',
                                selectedDbaRegistry?.RegConfigPan
                            )
                        }}
                        type="text"
                        value={selectedDbaRegistry?.RegConfigPan?.name_as_per_pan}
                    />
                    <InputContainer
                        label="Pan No"
                        name="pan_no"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigPan.pan_no',
                                selectedDbaRegistry?.RegConfigPan
                            )
                        }}
                        type="text"
                        value={selectedDbaRegistry?.RegConfigPan?.pan_no}
                    />
                    <InputContainer
                        label="Date Of Incorporation"
                        name="date_of_incorporation"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigPan.date_of_incorporation',
                                selectedDbaRegistry?.RegConfigPan
                            )
                        }}
                        type="text"
                        value={selectedDbaRegistry?.RegConfigPan?.date_of_incorporation}
                    />
                </div>
            }
            expandedPanel="pan info"
            headerTitle="PAN Info"
        />
    </>
)

export default DbaRegistriesPanInfoComponent;